const designData = [
  "Figma",
  "User Flows",
  "Adobe XD",
  "UI/UX Design",
  "Wireframes & Mock ups",
  "Graphic Design",
];

export default designData;
